var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcFailed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 48,
    viewBox: "0 0 47 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 3.75C34.5625 3.75 43.75 12.8438 43.75 24C43.75 35.25 34.6562 44.25 23.5 44.25C12.25 44.25 3.25 35.25 3.25 24C3.25 12.8438 12.25 3.75 23.5 3.75ZM23.5 0.75C10.6562 0.75 0.25 11.25 0.25 24C0.25 36.8438 10.6562 47.25 23.5 47.25C36.25 47.25 46.75 36.8438 46.75 24C46.75 11.25 36.25 0.75 23.5 0.75ZM22.375 12C21.7188 12 21.25 12.5625 21.25 13.2188L21.9062 28.9688C21.9062 29.5312 22.4688 30 23.0312 30H23.875C24.4375 30 25 29.5312 25 28.9688L25.6562 13.2188C25.6562 12.5625 25.1875 12 24.5312 12H22.375ZM23.5 31.875C22 31.875 20.875 33.0938 20.875 34.5C20.875 36 22 37.125 23.5 37.125C24.9062 37.125 26.125 36 26.125 34.5C26.125 33.0938 24.9062 31.875 23.5 31.875Z",
    fill: "#F72C40"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFailed);
export default __webpack_public_path__ + "static/media/ic-failed.54ab771ac5bbe9525e52785928807450.svg";
export { ForwardRef as ReactComponent };